<template>
  <f7-page name="Contact" class="profile">
    <f7-navbar title="Contact" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>


      <f7-row>
        <div class="col-40 col-sm-0">
          <div class="left-az-logo">
            <img src="../assets/images/left-logo.png" alt="" />
          </div>
        </div>
        <div class="col-60 col-sm-100">
                <f7-block class="contact-block npage-content">
          <p style="font-size: 20px; font-weight: bold; text-align: center">AstraZeneca</p>
          <ul>
            <li>Near East & Maghreb | MEA Region</li>
            <li>Sweifieh, BLDG 19 Abdelraheem Al-Haj Mohammad street<br>P.O.Box 17788<br>Zip Code 11195 Amman-Jordan</li>
            <!-- <li>New Cairo, Cairo – Egypt</li> -->
            <li>
              <div class="contact-item">
              <span>Email: </span>
              <div class="co-link">
                <a class="link external" href="mailto:azconnectnemag@astrazeneca.com">azconnectnemag@astrazeneca.com</a>
              </div>
              </div>
            </li>
            <li>
              <div class="contact-item">
              <span>Phone: </span>
              <div class="co-link">
                <a class="link external" href="tel:+96265827580"> +96265827580</a> 
              </div>
              </div>
            </li>
            <li>For Adverse Events reporting please send directly to : <a class="external" href="mailto:=patientsafety.ne@astrazeneca.com">patientsafety.ne@astrazeneca.com</a> 
          <br>
          Or contact our office on Tel: <a class="external" href="tel:+96265827580">+96265827580</a>, <a class="external" href="tel:+9611383647">+9611383647</a></li>
          </ul>
      </f7-block>
        </div>
      </f7-row>


    <!-- Event Header -->
    <!-- <div class="profile-banner BG"> -->
      <!-- <h2>Send your message</h2> -->

    <!-- Profile Content -->
    <!-- <div class="profile-content ">

    </div> -->

    <!-- </div> -->

  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      message: ''
    }
  },
  methods: {
    send: function() {

    }
  },
  mounted: function () {
    
  }
}
</script>
<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
  .contact-block {
    text-align: left
  }
  .contact-block p {
    font-size: 16px;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
  }
  .contact-block ul
  {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  .contact-block ul li 
  {
    font-size: 16px;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
  }
  .contact-item
  {
    display: flex;
    justify-content: flex-start;
    box-sizing: border-box;
  }
   .contact-item .co-link
   {
     margin-left: 8px;
   }
</style>
